import { render, staticRenderFns } from "./TeacherSta.vue?vue&type=template&id=5c52e414&scoped=true&"
import script from "./TeacherSta.vue?vue&type=script&lang=js&"
export * from "./TeacherSta.vue?vue&type=script&lang=js&"
import style0 from "./TeacherSta.vue?vue&type=style&index=0&id=5c52e414&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c52e414",
  null
  
)

export default component.exports